import React from 'react';
import { createRoot } from 'react-dom/client';
import './polyfills'; // Import polyfills first
import './index.css';
import App from './App';
import * as serviceWorker from './serviceWorker';
import { Provider } from 'react-redux';
import { store, persistor } from './redux/store.js';
import { PersistGate } from 'redux-persist/integration/react'

// Redirect hash-based routes to standard browser routes (e.g., /#/signup?ref=xxx to /signup?ref=xxx)
if (window.location.hash && window.location.hash.startsWith('#/')) {
  const targetPath = window.location.hash.slice(1);
  window.location.replace(window.location.origin + targetPath);
}

const container = document.getElementById('root');
const root = createRoot(container);

root.render(
  <Provider store={store}>
    <PersistGate loading={null} persistor={persistor}>
      <React.StrictMode>
        <App />
      </React.StrictMode>
    </PersistGate>
  </Provider>
);

// If you want your app to work offline and load faster, you can change
// unregister() to register() below. Note this comes with some pitfalls.
// Learn more about service workers: https://bit.ly/CRA-PWA
serviceWorker.unregister();
